<template>
    <aside class="user-detail-aside">
        <section class="info-basic">
            <a class="link-back" href="/terapeute">
                <svg height="17px" version="1.1" viewBox="0 0 16 17" width="16px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g id="Android-APP-wireframes" fill="none" fill-rule="evenodd" stroke="none" stroke-width="1">
                        <g id="4_inspirace-detail" fill="#5937B7" transform="translate(-20.000000, -44.000000)">
                            <g id="Top-Bar/Back-Icon">
                                <polygon id="back-arrow" points="36 51.20625 23.8 51.20625 29.4 45.50125 28 44.075 20 52.225 28 60.375 29.4 58.94875 23.8 53.24375 36 53.24375"></polygon>
                            </g>
                        </g>
                    </g>
                </svg>
                <span>{{ __("Back") }}</span>
            </a>

            <UserAvatar :user-info="coach.user" position="top" size="xlg" />

            <div class="basic-top">
                <h1 class="user-name">{{ coach.user.fullname }}</h1>
            </div>

            <div class="btn-group">
                <VButton :href="`/impersonate/take/${coach.user.id}`" :label="__('Switch to dashboard')" full-width size="sm" />
                <VButton :href="`/terapeut/${coach.id}/edit`" :label="__('Edit dietitian details')" full-width size="sm" variant="secondary" />
            </div>

            <input
                id="accepts_new_patients"
                :checked="coach.accepts_new_patients"
                class="input-checkbox checkbox-toggle"
                type="checkbox"
            />
            <label class="label-checkbox label-toggle" for="accepts_new_patients" @click="changePatientAcceptation">
                {{ __('Recruitment of new patients') }}
            </label>

            <CoachArchiveButton :coach="coach"></CoachArchiveButton>
        </section>

        <div class="info-secondary">
            <section class="info-input">
                <div class="input-wrapper">
                    <span>{{ __('Start of therapy') }}</span>
                    <strong>{{ moment(coach.start_date).format('LL') }}</strong>
                </div>

                <div class="input-wrapper">
                    <span>{{ __('E-mail') }}</span>
                    <a :href="'mailto:' + coach.user.email">{{ coach.user.email }}</a>
                </div>

                <div class="input-wrapper">
                    <span>{{ __('Phone') }}</span>
                    <strong>{{ coach.phone_international }}</strong>
                </div>

                <div class="input-wrapper">
                    <span class="input-margin">{{ __('Default availability') }}</span>
                    <ul>
                        <li v-for="{ date, times } in openingHours" :key="date">
                            {{ toDay(date) | capitalize }}
                            <ul>
                                <li v-for="([start, end], i) in times" :key="i">
                                    {{ toTimeRange(start, end) }}
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>

                <div class="input-wrapper">
                    <span>{{ __('Number of hours') }}</span>
                    <strong>{{ numberFormat(openingHoursDuration, 1) }} {{ __('h/month') }}</strong>
                </div>
            </section>
        </div>

        <flash-alert v-if="showAlert" :level="alertLevel" :text="alertMsg" @closeAlert="close()"></flash-alert>
    </aside>
</template>

<script>
import CoachArchiveButton from './CoachArchiveButton'

export default {
    components: {
        CoachArchiveButton
    },
    props: {
        coach: {
            type: Object,
            required: true
        },
        openingHours: {
            type: Array,
            required: true
        },
        openingHoursDuration: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            showAlert: false,
            alertLevel: null,
            alertMsg: null
        }
    },
    methods: {
        changePatientAcceptation() {
            const acceptsNewPatients = $('#accepts_new_patients').prop('checked')

            if (!acceptsNewPatients === true) {
                this.alertLevel = 'success'
                this.alertMsg = lang.get('Recruitment of new patients is activated.')
            } else {
                this.alertLevel = 'danger'
                this.alertMsg = lang.get('Recruitment of new patients is deactivated.')
            }

            this.showAlert = true

            axios
                .post(`/coaches/${this.coach.id}/accepts-new-patients`, {
                    accepts_new_patients: !acceptsNewPatients
                })
                .catch((e) => {
                    console.log(e.response)
                })
        },
        close() {
            this.showAlert = false
        }
    }
}
</script>
